const eng = () => {
    return {
        arias: {
            stepper: {
                start: "You are on step",
                end: "of"
            },
            back_button: "Back",
            cover_selection: "Cover number",
            image_to_load: "Upload image",
            image_load: "Uploading image",
            loaded_image: "Uploaded image",
            exampleDialogTitle: "Image example",
            next: "Next",
            prev: "Previous",
            fill_requironments: ""
        },
        general: {
            next: "Next",
            pageTitle: "Book creation"
        },
        error: {
            error_upload: "There was a problem to update the image",
            many_faces: "Please upload image with one face"
        },
        click_me: "Click me",
        choose: "Choose",
        i_want_this_template: "I want this story",
        shop_now: "Shop now",
        last_seen: "Last seen"
    };
};

export default eng;
